<div class="row align-items-center m-b-10">
  <div class="col-sm-12 col-lg-6">

    <div class="d-flex align-items-center flexmob">

      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">
        <!--<div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="receipt-pound" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>-->
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Notes to the Accounts
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            {{financialYear}}
          </h5>
        </div>
      </div>


    </div>
  </div>
  <div class="col-sm-12 col-lg-6  text-end" *ngIf="this.LYselectedNotes.length>0">

    <div class="d-flex align-items-center justify-content-end">
      <!--<button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="!editmode" (click)="edit()">
        <div class="d-flex text-black">
          <i-tabler class="icon-14 m-r-4 text-black" name="edit"></i-tabler><span class="f-s-12 text-black"> Edit Details</span>
        </div>
      </button>-->
      <!--<p class="f-s-14 f-w-400 m-r-10">
        Previous Year Select all
      </p>
      <mat-slide-toggle [disabled]="apFinalised" color="primary" (change)="LYselectAllNotes1($event)"></mat-slide-toggle>-->
      <button mat-flat-button [disabled]="apFinalised" (click)="BringForwardNotes($event)">
        <div class="d-flex align-items-center">
          <i-tabler class="icon-18 m-r-10" name="refresh"></i-tabler> Bring Forward Notes <!--Trial Balance-->
        </div>
      </button>
    </div>
  </div>
</div>

<!--Period Finalised & Ready to Submit-->
<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-20 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0 m-t-20">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->


<div class="container-fluid p-20 p-x-0 p-t-0">
  <mat-card class="m-t-16" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-0">

      <div class="p-16 b-b-1" style=" background: #e6f1f0; border-radius: 5px 5px 0px 0px;">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="m-t-10 f-s-16 f-w-600">Select Notes to Include</h4>
            <p class="f-w-500 f-s-14 text-black-50 m-0">Choose the notes that are relevant to your financial statements. Required notes are pre-selected.</p>
          </div>
          <div class="col-lg-4 text-end" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
            <div class="d-flex gap-10 align-items-center justify-content-end">
              <p class="f-s-14 f-w-400 m-r-10">
                Select all
              </p>
              <mat-slide-toggle *ngIf="this.Account_Type === 'Amended'" [disabled]="apFinalised" color="primary" [checked]="this.selectedNotes.length>=30" (change)="selectAllNotes1($event)"></mat-slide-toggle>
              <mat-slide-toggle *ngIf="this.Account_Type === 'Original'" [disabled]="apFinalised" color="primary" [checked]="this.selectedNotes.length>=29" (change)="selectAllNotes1($event)"></mat-slide-toggle>
            </div>
          </div>
          <div class="col-lg-4 text-end" *ngIf=" accounting_Method =='Cash (Receipts & Payments)'">
            <div class="d-flex gap-10 align-items-center justify-content-end">
              <p class="f-s-14 f-w-400 m-r-10">
                Select all
              </p>
              <mat-slide-toggle [disabled]="apFinalised" color="primary" [checked]="isAllNotesSelected('cash')" (change)="onSelectAllToggle($event, 'cash')"></mat-slide-toggle>
            </div>
          </div>
          <!--<div class="col-lg-12 text-end" *ngIf="this.LYselectedNotes.length>0">
            <div class="d-flex gap-10 align-items-center justify-content-end">
              <p class="f-s-14 f-w-400 m-r-10">
               Previous Year Select all
              </p>
              <mat-slide-toggle  [disabled]="apFinalised" color="primary" (change)="LYselectAllNotes1($event)"></mat-slide-toggle>
            </div>
          </div>-->
        </div>
      </div>

      <!--<div class="notes-list-container" style="max-height: 600px; overflow-y: auto;">-->
      <div class="notes-list-container" style="max-height: 550px; overflow-y: auto;">
        <!--<div class="container-fluid p-24">-->
        <div class="container-fluid p-12">
          <fieldset [disabled]="apFinalised" [ngClass]="apFinalised  ? 'pointer-none' : '' ">
            <div class="row m-t-0" style="row-gap: 12px;">


              <div class="col-lg-4" *ngIf="this.Account_Type=='Amended'">
                <!--<div class="theme-borders b-1 p-x-10 p-y-8 rounded cust-center-align" style="background: #f5f5f5 !important">-->
                <div class="theme-borders b-1 p-x-10 p-y-8 b-r-6 cust-center-align" style="border: 1px solid #8db7b3 !important; background: #d1e8e6; cursor: no-drop;">
                  <div class="d-flex align-items-center">
                    <div class="checkbox-container" style="pointer-events: none;">
                      <i-tabler class="icon-22 custom-checkbox-icon"
                                name="checks"
                                style="color: #939292; stroke: #107279 !important;">
                      </i-tabler>
                      <div class="d-flex align-items-center w-100 justify-content-between">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          <!--Note 30:--> <span class="f-w-400">Revised Statements</span>
                        </mat-label>
                        <!--<mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 " style="pointer-events: none !important;" *ngIf="this.Account_Type=='Original'">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note3')  ? 'theme-border' : '' " (click)="selectnote('Note3',$event)" style="cursor: pointer; background: #f5f5f5;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note30')  ? 'theme-border' : '' " (click)="selectnote('Note30',$event)" style="cursor: pointer; background: #f5f5f5;">
                  <div class="checkbox-container" style="background: none; ">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note30')  ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note30')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 30:--> <span class="f-w-400">Revised Statements</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <!--<div class="theme-borders b-1 p-x-10 p-y-8 rounded cust-center-align" style="background: #f5f5f5 !important;">-->
                <div class="theme-borders b-1 p-x-10 p-y-8 b-r-6 cust-center-align" style="border: 1px solid #8db7b3 !important; background: #d1e8e6; cursor: no-drop; ">
                  <div class="d-flex align-items-center gap-8">
                    <div class="checkbox-container" style="pointer-events: none;">
                      <i-tabler class="icon-22 custom-checkbox-icon"
                                name="checks"
                                style="color: #939292; stroke:#107279 !important;">
                      </i-tabler>
                    </div>
                    <div class="d-flex align-items-center w-100 justify-content-between">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        <!--Note 1:--> <span class="f-w-400">General Information </span>
                      </mat-label>
                      <!--<mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>-->
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="theme-borders b-1 p-x-10 p-y-8 rounded cust-center-align" style="background: #f5f5f5 !important;">-->
                <div class="theme-borders b-1 p-x-10 p-y-8 b-r-6 cust-center-align" style="border: 1px solid #8db7b3 !important; background: #d1e8e6; cursor: no-drop; ">
                  <div class="d-flex align-items-center gap-8">
                    <div class="checkbox-container" style="pointer-events: none;">
                      <i-tabler class="icon-22 custom-checkbox-icon"
                                name="checks"
                                style="color: #939292; stroke: #107279 !important;">
                      </i-tabler>
                    </div>
                    <div class="d-flex align-items-center w-100 justify-content-between">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        <!--Note 2:--> <span class="f-w-400">Accounting Polices</span>
                      </mat-label>
                      <!--<mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>-->
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="col-lg-4" *ngIf="Charity_Type=='Unincorporated Charity' && accounting_Method =='Cash (Receipts & Payments)'">-->
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note1')  ? 'theme-border' : '' " (click)="selectnote('Note1',$event)" style="cursor: pointer;">-->
                <!--<div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note1')  ? 'theme-border' : '' " (click)="selectnote('Note1',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note1')  ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note1')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">-->
                        <!--Note 1:--> <!--<span class="f-w-400">General Information </span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4" *ngIf="Charity_Type=='Unincorporated Charity' && accounting_Method !='Accruals (FRS 102 SORP)'">-->
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note2')  ? 'theme-border' : '' " (click)="selectnote('Note2',$event)" style="cursor: pointer;">-->
                <!--<div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note2')  ? 'theme-border' : '' " (click)="selectnote('Note2',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note2')  ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note2')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">-->
                        <!--Note 2:--> <!--<span class="f-w-400">Accounting Polices</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>-->
              <div class="col-lg-4" style="pointer-events: none !important;" *ngIf="accounting_Method !='Accruals (FRS 102 SORP)'">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note3')  ? 'theme-border' : '' " (click)="selectnote('Note3',$event)" style="cursor: pointer; background: #f5f5f5;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note3')  ? 'theme-border' : '' " (click)="selectnote('Note3',$event)" style="cursor: pointer; background: #f5f5f5;">
                  <div class="checkbox-container" style="background: none; ">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note3')  ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note3')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 3:--> <span class="f-w-400">Analysis of Income</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note3')  ? 'theme-border' : '' " (click)="selectnote('Note3',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note3')  ? 'theme-border' : '' " (click)="selectnote('Note3',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none; ">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note3')  ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note3')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 3:--> <span class="f-w-400">Analysis of Income</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note4') ? 'theme-border' : '' " (click)="selectnote('Note4',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note4') ? 'theme-border' : '' " (click)="selectnote('Note4',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 4: Expenditure
                        </mat-label>
                        <mat-hint class="f-s-12"> Expenditure</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note4') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note4')  ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 4:--> <span class="f-w-400">Analysis of Receipts of Government Grants</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note5') ? 'theme-border' : '' " (click)="selectnote('Note5',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note5') ? 'theme-border' : '' " (click)="selectnote('Note5',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 5: Tangible fixed assets
                        </mat-label>
                        <mat-hint class="f-s-12">  Fixed Assets</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note5') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note5') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 5:--> <span class="f-w-400">Donated Goods, Facilities and Services</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4" style="pointer-events: none !important;" *ngIf="accounting_Method !='Accruals (FRS 102 SORP)'">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note6') ? 'theme-border' : '' " (click)="selectnote('Note6',$event)" style="cursor: pointer; background: #f5f5f5;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note6') ? 'theme-border' : '' " (click)="selectnote('Note6',$event)" style="cursor: pointer; background: #f5f5f5;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 6: Investments
                        </mat-label>
                        <mat-hint class="f-s-12">  Investments</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note6')? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note6') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 6:--> <span class="f-w-400"> Analysis of Expenditure</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4" *ngIf="accounting_Method =='Accruals (FRS 102 SORP)'">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note6') ? 'theme-border' : '' " (click)="selectnote('Note6',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note6') ? 'theme-border' : '' " (click)="selectnote('Note6',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note6')? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note6') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 6:--> <span class="f-w-400"> Analysis of Expenditure</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note7') ? 'theme-border' : '' " (click)="selectnote('Note7',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note7') ? 'theme-border' : '' " (click)="selectnote('Note7',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 7: Debtors
                        </mat-label>
                        <mat-hint class="f-s-12">  Current Assets</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note7') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note7') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 7:--> <span class="f-w-400">Extraordinary Items</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note8') ? 'theme-border' : '' " (click)="selectnote('Note8',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note8') ? 'theme-border' : '' " (click)="selectnote('Note8',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 8: Cash at bank and in hand
                        </mat-label>
                        <mat-hint class="f-s-12">  Current Assets</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note8') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note8') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 8:--> <span class="f-w-400">Funds Received as Agent</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note9') ? 'theme-border' : '' " (click)="selectnote('Note9',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note9') ? 'theme-border' : '' " (click)="selectnote('Note9',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 9: Creditors
                        </mat-label>
                        <mat-hint class="f-s-12">  Liabilities</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note9') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note9') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 9:--> <span class="f-w-400">Support Costs</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note10') ? 'theme-border' : '' " (click)="selectnote('Note10',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note10') ? 'theme-border' : '' " (click)="selectnote('Note10',$event)" style="cursor: pointer;">
                  <!--<mat-checkbox color="warning" class="text-right f-w-600">
                    <div class="d-flex align-items-start">
                      <div class="text-left">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          Note 10: Financial instruments
                        </mat-label>
                        <mat-hint class="f-s-12">  Financial Instruments</mat-hint>
                      </div>
                    </div>
                  </mat-checkbox>-->
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note10') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note10') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 10:--> <span class="f-w-400">Fees for examination of the accounts</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="col-lg-4">
              <div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note11') ? 'theme-border' : '' " (click)="selectnote('Note11',$event)" style="cursor: pointer;">
                <div class="checkbox-container" style="background: none;">
                  <i-tabler class="icon-22 custom-checkbox-icon"
                            [name]="selectedNotes.includes('Note11') ? 'checks' : 'circle'"
                            [style.color]="selectedNotes.includes('Note11') ? '#0f867d' : '#d5d5d5'">
                  </i-tabler>-->
              <!--<div class="text-content">
                <mat-label class="f-s-14 f-w-600 d-block heading">
                  Note 11: <span class="f-w-400">Paid Employees</span>
                </mat-label>
              </div>-->
              <!--<div class="d-flex align-items-center w-100 justify-content-between">
                      <mat-label class="f-s-14 f-w-600 d-block  heading">
                        Note 11: <span class="f-w-400">Paid Employees </span>
                      </mat-label>
                      <mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>
                    </div>
                  </div>


                </div>

              </div>-->

              <div class="col-lg-4">
                <!--<div class="theme-borders b-1 p-x-10 p-y-8 rounded cust-center-align" style="background: #f5f5f5 !important">-->
                <div class="theme-borders b-1 p-x-10 p-y-8 b-r-6 cust-center-align" style="border: 1px solid #8db7b3 !important; background: #d1e8e6; cursor: no-drop; ">
                  <div class="d-flex align-items-center">
                    <div class="checkbox-container" style="pointer-events: none;">
                      <i-tabler class="icon-22 custom-checkbox-icon"
                                name="checks"
                                style="color: #939292; stroke: #107279 !important;">
                      </i-tabler>
                      <div class="d-flex align-items-center w-100 justify-content-between">
                        <mat-label class="f-s-14 f-w-600 d-block  heading">
                          <!--Note 11:--> <span class="f-w-400">Paid Employees </span>
                        </mat-label>
                        <!--<mat-hint class="rounded cust-danger p-4 p-x-12 f-s-12 f-w-600"> Required</mat-hint>-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note12') ? 'theme-border' : '' " (click)="selectnote('Note12',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note12') ? 'theme-border' : '' " (click)="selectnote('Note12',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note12') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note12') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 12:--> <span class="f-w-400">Pension Scheme </span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note13') ? 'theme-border' : '' " (click)="selectnote('Note13',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note13') ? 'theme-border' : '' " (click)="selectnote('Note13',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note13') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note13') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 13:--> <span class="f-w-400">Grantmaking</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note14') ? 'theme-border' : '' " (click)="selectnote('Note14',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note14') ? 'theme-border' : '' " (click)="selectnote('Note14',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note14') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note14') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 14:--> <span class="f-w-400">Tangible Fixed Assets</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note15') ? 'theme-border' : '' " (click)="selectnote('Note15',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note15') ? 'theme-border' : '' " (click)="selectnote('Note15',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note15') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note15') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 15:--> <span class="f-w-400">Intangible Assets</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note16') ? 'theme-border' : '' " (click)="selectnote('Note16',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note16') ? 'theme-border' : '' " (click)="selectnote('Note16',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note16') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note16') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 16:--> <span class="f-w-400">Heritage Assets</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note17') ? 'theme-border' : '' " (click)="selectnote('Note17',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note17') ? 'theme-border' : '' " (click)="selectnote('Note17',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note17') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note17') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 17:--> <span class="f-w-400">Investment Assets</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note18') ? 'theme-border' : '' " (click)="selectnote('Note18',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note18') ? 'theme-border' : '' " (click)="selectnote('Note18',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note18') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note18') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 18:--> <span class="f-w-400">Stocks</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note19') ? 'theme-border' : '' " (click)="selectnote('Note19',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note19') ? 'theme-border' : '' " (click)="selectnote('Note19',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note19') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note19') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 19:--> <span class="f-w-400">Debtors and Prepayments</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note20') ? 'theme-border' : '' " (click)="selectnote('Note20',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note20') ? 'theme-border' : '' " (click)="selectnote('Note20',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note20') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note20') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 20:--> <span class="f-w-400">Creditors and Accruals</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note21') ? 'theme-border' : '' " (click)="selectnote('Note21',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note21') ? 'theme-border' : '' " (click)="selectnote('Note21',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note21') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note21') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 21:--> <span class="f-w-400">Provisions for Liabilities and Charges</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note22') ? 'theme-border' : '' " (click)="selectnote('Note22',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note22') ? 'theme-border' : '' " (click)="selectnote('Note22',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note22') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note22') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content" style="width:80%">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 22:--> <span class="f-w-400">Disclosures for Debtors & Creditors </span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note23') ? 'theme-border' : '' " (click)="selectnote('Note23',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note23') ? 'theme-border' : '' " (click)="selectnote('Note23',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note23') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note23') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 23:--> <span class="f-w-400">Contingent Liabilities and Contingent Assets</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note24') ? 'theme-border' : '' " (click)="selectnote('Note24',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note24') ? 'theme-border' : '' " (click)="selectnote('Note24',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note24') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note24') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 24:--> <span class="f-w-400">Cash and Cash equivalents</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note25') ? 'theme-border' : '' " (click)="selectnote('Note25',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note25') ? 'theme-border' : '' " (click)="selectnote('Note25',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note25') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note25') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 25:--> <span class="f-w-400">Fair Value of Assets and Liabilities</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note26') ? 'theme-border' : '' " (click)="selectnote('Note26',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note26') ? 'theme-border' : '' " (click)="selectnote('Note26',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note26') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note26') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 26:--> <span class="f-w-400">Events after the end of the reporting period</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note27') ? 'theme-border' : '' " (click)="selectnote('Note27',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note27') ? 'theme-border' : '' " (click)="selectnote('Note27',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note27') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note27') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 27:--> <span class="f-w-400">Charity Funds</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note28') ? 'theme-border' : '' " (click)="selectnote('Note28',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note28') ? 'theme-border' : '' " (click)="selectnote('Note28',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note28') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note28') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 28:--> <span class="f-w-400">Transactions with Trustees and Related Parties</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note29') ? 'theme-border' : '' " (click)="selectnote('Note29',$event)" style="cursor: pointer;">-->
                <div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note29') ? 'theme-border' : '' " (click)="selectnote('Note29',$event)" style="cursor: pointer;">
                  <div class="checkbox-container" style="background: none;">
                    <i-tabler class="icon-22 custom-checkbox-icon"
                              [name]="selectedNotes.includes('Note29') ? 'checks' : 'circle'"
                              [style.color]="selectedNotes.includes('Note29') ? '#0f867d' : '#d5d5d5'">
                    </i-tabler>
                    <div class="text-content">
                      <mat-label class="f-s-14 f-w-600 d-block heading">
                        <!--Note 29:--> <span class="f-w-400">Additional Disclosures</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>
              <!--<div class="col-lg-4">-->
              <!--<div class="b-1 p-x-10 p-y-8 rounded cust-center-align" [ngClass]="selectedNotes.includes('Note29') ? 'theme-border' : '' " (click)="selectnote('Note29',$event)" style="cursor: pointer;">-->
              <!--<div class="b-1 p-x-10 p-y-8 b-r-6 cust-center-align" [ngClass]="selectedNotes.includes('Note30') ? 'theme-border' : '' " (click)="selectnote('Note30',$event)" style="cursor: pointer;">
              <div class="checkbox-container" style="background: none;">
                <i-tabler class="icon-22 custom-checkbox-icon"
                          [name]="selectedNotes.includes('Note30') ? 'checks' : 'circle'"
                          [style.color]="selectedNotes.includes('Note30') ? '#0f867d' : '#d5d5d5'">
                </i-tabler>
                <div class="text-content">
                  <mat-label class="f-s-14 f-w-600 d-block heading">-->
              <!--Note 30:-->
              <!--<span class="f-w-400">Revised Statements</span>
                      </mat-label>
                    </div>
                  </div>
                </div>
              </div>-->


            </div>
          </fieldset>
        </div>
      </div>


      <div class="container-fluid">
        <div class="row b-t-1 p-t-24 p-b-20 p-x-30" style="row-gap: 10px;">

          <div class="col-lg-6 text-right">
            <div class="row align-items-center">
              <div class="col-lg-2 text-left btnRespBottom">
                <button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="accounting_Method=='Accruals (FRS 102 SORP)'" (click)="backToBalanceSheet()">
                  <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="accounting_Method!='Accruals (FRS 102 SORP)'" (click)="backToAssets()">
                  <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <!--<div class="col-lg-4 text-left">-->
              <div class="col-lg-3 text-left">
                <!--<mat-label class="f-s-14 f-w-600 m-t-8 m-b-8 d-block">Jump to next section</mat-label>-->
                <mat-label class="f-s-14 f-w-600 m-t-8 m-b-8 d-block p-l-12">Jump to next section</mat-label>
              </div>
              <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100 no-subscript">
                  <mat-select [(ngModel)]="jumpsection" placeholder="Select Notes Section">

                    <mat-option *ngFor="let note of getFilteredFullNames()" [value]="note.code" (onSelectionChange)="onJumpSelection(note.code, $event)">
                      {{ note.name }}
                    </mat-option>

                  </mat-select>


                  <!--<mat-select [(ngModel)]="jumpsection" (selectionChange)="save()" value="notes" placeholder="Select Notes Section" [disabled]="!UserRoleAccess?.m1View">-->
                  <!--   <mat-option value="">Select Notes Section</mat-option>-->
                  <!--<mat-option *ngFor="let note of getFilteredFullNames()" [value]="note.code">
                  {{ note.name }}
                   </mat-option>
                  </mat-select>-->
                </mat-form-field>
              </div>
            </div>
          </div>

          <div class="col-lg-6 text-right">
            <div class="text-left btnRespTop">
              <button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="accounting_Method=='Accruals (FRS 102 SORP)'" (click)="backToBalanceSheet()">
                <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-warning text-end" *ngIf="accounting_Method!='Accruals (FRS 102 SORP)'" (click)="backToAssets()">
                <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                </div>
              </button>
            </div>
            <button mat-flat-button color="primary" *ngIf="selectedNotes.includes('trusteeannualreport')" (click)="save()" [disabled]="!UserRoleAccess?.m1View">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-18 m-r-10" name="circle-check"></i-tabler> Continue with Selected Notes ({{(selectedNotes.length)-1}})
              </div>
            </button>
            <button mat-flat-button color="primary" *ngIf="!selectedNotes.includes('trusteeannualreport')" (click)="save()" [disabled]="!UserRoleAccess?.m1View">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-18 m-r-10" name="circle-check"></i-tabler> Continue with Selected Notes ({{selectedNotes.length}})
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>

<div class="spinner-container" *ngIf="ShowSpinner">
  <img src="../../../../assets/images/backgrounds/acct-loading2.gif" />
</div>

